import { getDomainKey } from './domainLanguages';

/** Plans in DB are RUB — display equivalents for international domains */
const CURRENCY_BY_DOMAIN = {
    'sportprogress.ru': { code: 'RUB', symbol: '₽', locale: 'ru-RU', rubMultiplier: 1 },
    'sportprogress.app': { code: 'USD', symbol: '$', locale: 'en-US', rubMultiplier: 1 / 90 },
    'sportprogress.online': { code: 'EUR', symbol: '€', locale: 'de-DE', rubMultiplier: 1 / 98 },
    localhost: { code: 'RUB', symbol: '₽', locale: 'ru-RU', rubMultiplier: 1 },
};

export function getPricingCurrency() {
    const key = getDomainKey();
    return CURRENCY_BY_DOMAIN[key] || CURRENCY_BY_DOMAIN.localhost;
}

export function formatPlanPrice(rubAmount, currency = getPricingCurrency()) {
    const amount = Math.round((rubAmount || 0) * currency.rubMultiplier);
    if (currency.code === 'RUB') {
        return new Intl.NumberFormat(currency.locale).format(amount);
    }
    return new Intl.NumberFormat(currency.locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
}
